import { z } from 'zod';
import {
  JsonValueSchema,
  TargetTypeSchema,
  TraceStatusSchema,
} from '@terra/shared-schemas-ai';

/**
 * Hand-rolled base for trace HTTP DTOs. Decoupled from the generated
 * Prisma Zod schema. See `BaseFindingDtoSchema` for rationale.
 */
export const BaseTraceDtoSchema = z.object({
  id: z.string(),
  tenantId: z.string().nullable(),
  targetId: z.string(),
  targetType: TargetTypeSchema,
  threadId: z.string(),
  name: z.string(),
  status: TraceStatusSchema,
  signalId: z.string().nullable(),
  executionId: z.string().nullable(),
  metadata: JsonValueSchema.nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
});

export type BaseTraceDto = z.infer<typeof BaseTraceDtoSchema>;

/**
 * App-bounded variant — `applicationId` for web-application scoped routes.
 * Responses map from stored `targetId` / `targetType` in the orchestrator.
 */
export const BaseAppTraceDtoSchema = BaseTraceDtoSchema.omit({
  targetId: true,
  targetType: true,
}).extend({
  applicationId: z.string(),
});

export type BaseAppTraceDto = z.infer<typeof BaseAppTraceDtoSchema>;
